<div 
    class="scenario-subtitle"
    [style.fontWeight]="fontWeight"
    [style.fontSize]="fontSize + 'px'"
>{{label}}</div>
